import { Box, styled, Typography } from '@mui/material';
import { HOME_GRID_MAX_WIDTH } from './homeGridLayout';

/** @deprecated Fixed card width — grid cells are now fluid; kept for legacy imports */
export const CARD_WIDTH = 211;

/** Outer shell: max width + horizontal padding (matches Paper content inset) */
export const ScrollableContainer = styled(Box)(({ theme }) => ({
    boxSizing: 'border-box',
    maxWidth: HOME_GRID_MAX_WIDTH,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(2),
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none'
    }
}));

/** Responsive product grid — shared by Home and item detail carousels */
export const ProductGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    width: '100%',
    boxSizing: 'border-box',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    columnGap: theme.spacing(1.5),
    rowGap: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        columnGap: theme.spacing(2),
        rowGap: theme.spacing(2)
    },
    [theme.breakpoints.up('md')]: {
        gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
        columnGap: theme.spacing(3),
        rowGap: theme.spacing(3)
    }
}));

/** Grid cell — card fills column; no extra margins (gap handled by grid) */
export const ItemWrapper = styled(Box)({
    boxSizing: 'border-box',
    position: 'relative',
    minWidth: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& > a': {
        display: 'flex',
        flex: 1,
        minHeight: 0,
        width: '100%'
    }
});

export const Spinner = styled('div')(({ theme }) => ({
    border: `10px solid ${theme.palette.grey[200]}`,
    borderRadius: '50%',
    borderTop: `10px solid ${theme.palette.primary.main}`,
    width: 60,
    height: 60,
    animation: 'spin 2s linear infinite',
    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
    }
}));

export const TitleWrapper = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 600,
    margin: theme.spacing(3, 2)
}));
